import React, { useState } from 'react';
import { Button, Flex, Icon, Text, Modal, ModalHeader, ModalBody, Link, Grid, } from '@spothero/ui';
import IconCheckmarkShieldFilled from '@spothero/icons/checkmark-shield-filled';
import FormatUtils from 'utils/format';
const ParkedCarProtectionDetails = ({ carProtectionAddOn, onTrackedClick, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleOpen = () => setIsOpen(prev => !prev);
    const { context: { faqLink, claimLink, phoneNumber, termsAndConditionsLink }, } = carProtectionAddOn;
    const handleClick = clickTarget => {
        onTrackedClick({ clickTarget, isReservationChange: false });
    };
    const handleModalToggle = () => {
        if (isOpen) {
            handleClick('Parked Car Protection Details Close');
        }
        else {
            handleClick('Parked Car Protection Details');
        }
        toggleOpen();
    };
    return (<Grid borderBottomWidth="1px" borderColor="gray.100" padding={4} flexDirection="column" columnGap={2} gap={0} gridTemplateColumns="24px 1fr">
            <Icon as={IconCheckmarkShieldFilled} width={6} height="auto" color="green"/>
            <Flex alignItems="center" justifyContent="space-between">
                <Text lineHeight={1.4} color="green">
                    Parked Car Protection
                </Text>

                <Button fontFamily="body" variant="tertiary" onClick={handleModalToggle} sx={{
            '@media print': {
                display: 'none',
            },
        }}>
                    Details
                </Button>
            </Flex>

            <Modal size="sm" hasHeader isOpen={isOpen} onClose={handleModalToggle}>
                <ModalHeader>Parked Car Protection</ModalHeader>
                <ModalBody flexDirection="column">
                    <Link href={faqLink} onClick={() => handleClick('Parked Car Protection FAQ')} target="_blank" rel="noopener noreferrer">
                        <Button marginTop={1} marginBottom={4} width="100%" variant="secondary">
                            Read the FAQ
                        </Button>
                    </Link>

                    <Link href={claimLink} onClick={() => handleClick('Parked Car Protection File A Claim')} target="_blank" rel="noopener noreferrer">
                        <Button marginBottom={4} width="100%" variant="secondary">
                            File a Claim
                        </Button>
                    </Link>

                    <Text marginBottom={2} fontSize="sm" lineHeight="1.4">
                        Provided by our partner Park &rsquo;N&rsquo; Protect.
                    </Text>
                    <Text marginBottom={4} fontSize="sm" lineHeight="1.4">
                        Questions? Call Park &rsquo;N&rsquo; Protect at{' '}
                        <Link href={`tel:${phoneNumber}`} onClick={() => handleClick('Parked Car Protection Contact Phone')} target="_blank" rel="noopener noreferrer">
                            {FormatUtils.phone(phoneNumber)}
                        </Link>
                        .
                    </Text>
                    <Text fontSize="xs" lineHeight="1.4">
                        See applicable{' '}
                        <Link href={termsAndConditionsLink} onClick={() => handleClick('Parked Car Protection Terms and Conditions')} target="_blank" rel="noopener noreferrer">
                            Terms & Conditions
                        </Link>
                        .
                    </Text>
                </ModalBody>
            </Modal>
        </Grid>);
};
export default ParkedCarProtectionDetails;
